/**
 * Styled components for WithVerticalSources
 */

import styled from 'styled-components';

import { IOcAppTheme } from '../../config/ocTheme';
import { withAlpha } from '../../styles/colorUtils';
import { ocScrollbarStyles } from '../../styles/OcScrollbar.styled';

/**
 * Main panel container - creates the split layout
 * Applies OC scrollbar styles to all descendants (like hl-scroll-container-apply-to-all)
 */
export const VerticalSourcesPanel = styled.div`
  display: flex;
  flex: 1 1;
  min-height: 80%;
  flex-basis: 80%;

  /* Apply OC scrollbar styling to all descendant scrollable elements */
  & * {
    ${({ theme }) => ocScrollbarStyles(withAlpha((theme as IOcAppTheme).color.textPrimary || theme.color.messageInputButton, 0.5))}
  }
`;

/**
 * Chat wrapper - contains transcript and input (grows to fill available space)
 * Conditionally centers content in initial state (no messages)
 */
export const VerticalSourcesContent = styled.div<{ $isInitialState?: boolean }>`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
`;
